import "./App.css";
import { ChatEngine } from "react-chat-engine";

import ChatFeed from "./component/chatfeed";
import LoginForm from "./component/LoginForm";
function App() {
  if (!localStorage.getItem("userName")) return <LoginForm></LoginForm>;
  return (
    <>
      <ChatEngine
        height="101vh"
        userName={localStorage.getItem("userName")}
        userSecret={localStorage.getItem("password")}
        projectID="cc108e84-5257-4bea-8802-18f6d0ebf7a0"
        // renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
      />
    </>
  );
}

export default App;
